export default __webpack_public_path__ + "static/media/tickandarrow.f36dc635.svg";